import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './safe-html.pipe';
import { UserLanguagePipe } from './user-language.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { WhatsappPipe } from './whatsapp-text.pipe';



@NgModule({
  declarations: [SafeHtmlPipe,UserLanguagePipe, LinkifyPipe, WhatsappPipe],
  imports: [
    CommonModule
  ],
  exports:[
    SafeHtmlPipe,
    UserLanguagePipe,
    LinkifyPipe,
    WhatsappPipe
  ],
  providers:[]
})
export class InovaCorePipesModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: InovaCorePipesModule
    };
  }
 }
